import { Checkbox, CheckboxChangeEvent } from '@pay-com/components'
import {
  Controller,
  FieldPath,
  FieldValues,
  UseFormReturn,
  useFormContext
} from 'react-hook-form'

type ControlledCheckboxProps<T extends FieldValues> = {
  name: FieldPath<T>
  label?: string
  checkboxLabel?: string
  disabled?: boolean
  isLoading?: boolean
  className?: string
  onChange?: (checked: boolean, methods: UseFormReturn<T>) => void
}

export const ControlledCheckbox = <T extends FieldValues>({
  name,
  label,
  checkboxLabel,
  disabled,
  isLoading,
  className,
  onChange
}: ControlledCheckboxProps<T>) => {
  const methods = useFormContext<T>()
  const { control } = methods

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { error } = fieldState

        return (
          <div className="flex flex-col gap-2">
            {label && (
              <span className="text-sm font-medium text-blueGray-900">
                {label}
              </span>
            )}
            <Checkbox
              {...field}
              checked={!!field.value}
              onChange={(e: CheckboxChangeEvent) => {
                const checked = !!e.target.value
                onChange?.(checked, methods)
                field.onChange(e.target.value)
              }}
              label={checkboxLabel}
              disabled={disabled || isLoading}
              error={Boolean(error)}
              className={className}
            />
          </div>
        )
      }}
    />
  )
}
